import { baseAlert } from "./baseAlert";

export const standardInfoAlert = (text: string) => {
  return baseAlert.fire({
    icon: "info",
    text: text,
  });
};
